import { render } from "./FGCPrizePoolView.vue?vue&type=template&id=1093cd0f&scoped=true&ts=true"
import script from "./FGCPrizePoolView.vue?vue&type=script&lang=ts"
export * from "./FGCPrizePoolView.vue?vue&type=script&lang=ts"

import "./FGCPrizePoolView.vue?vue&type=style&index=0&id=1093cd0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1093cd0f"]])

export default __exports__